import { createSelector } from 'reselect';
import { selectors as entitySelectors } from 'schemas/duck';
import { stateKey } from 'utils';
import reducer from './reducers';

const STATE_KEY = stateKey(reducer);

const mapOptions = ({ id, name: label }) => ({ value: id.toString(), label });

const sortLabels = ({ label: l1 }, { label: l2 }) => l1.localeCompare(l2);

const selectCities = createSelector(
  entitySelectors.entities,
  ({ city = {} }) =>
    Object.values(city)
      .map(mapOptions)
      .sort(sortLabels)
);

const selectCuisines = createSelector(
  entitySelectors.entities,
  ({ cuisine = {} }) =>
    Object.values(cuisine)
      .map(mapOptions)
      .sort(sortLabels)
);

const selectDishTags = createSelector(
  entitySelectors.entities,
  ({ tag = {} }) => {
    return Object.values(tag)
      .filter(({ tagDimension }) => tagDimension === 'DISH')
      .map(mapOptions)
      .sort(sortLabels)
  }
);

// const selectStory = state => state[STATE_KEY].story;
const selectStory = (state, props) => {
  if (state[STATE_KEY].story.linkTitle === props.match.params.slug) {
    return state[STATE_KEY].story;
  }
  else {
    return undefined;
  }
}

const selectEateries = state => state[STATE_KEY].eateries;

const selectIsSaving = state => state[STATE_KEY].isSaving;

const selectEditedSlug = state => state[STATE_KEY].editedSlug;

export default {
  selectCities,
  selectCuisines,
  selectDishTags,
  selectEateries,
  selectIsSaving,
  selectStory,
  selectEditedSlug
};
